import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `textarea.input`.
export const styles = {
  textarea: {
    kzqmXN: "xh8yej3",
    kAzted: "x1qafhyn",
    kWkggS: "xvys5x3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    k8WAf4: "x1pl3ix2",
    kg3NbH: "xy65nll",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kLWn49: "x1evy7pa",
    kHenm0: "x288g5",
    kI3sdo: "x1a2a7pz",
    kmkexE: "x1k3q35m",
    k8Qsv1: "x1l9ba8j",
    k4mVRr: "xwo1ljg",
    kWEjV4: "xs8x3o8",
    kL3a3j: "xxgwfau",
    kWCcOm: "xfqoyci",
    kYPGJ8: "x1s07b3s",
    $$css: true
  },
  invalid: {
    kVAM5u: "x1vgqim1",
    k4mVRr: "x1x16wwa",
    kWEjV4: "x10li9c4",
    $$css: true
  }
};